import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonSvgIconsComponent } from "../../../shared/components/common-svg-icons/common-svg-icons.component";
import { NgbInputDatepicker, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CurrencyPipe, NgClass, NgForOf, NgIf, NgSwitchCase } from "@angular/common";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { GeneralService } from "../../../core/services/general.service";
import { TableService } from "../../../core/services/table.service";
import { ServicesService } from "../../../core/services/services.service";
import { ConfirmComponent } from "../../../shared/components/generalModals/confirm/confirm.component";
import { FeatherIconsComponent } from "../../../shared/components/feather-icons/feather-icons.component";
import { AuthService } from "../../../core/services/auth.service";
import { LocationPickerComponent } from '../../../shared/components/location-picker/location-picker.component';
import { ServiceSummaryComponent } from './service-summary/service-summary.component';

@Component({
  selector: 'app-new',
  standalone: true,
  imports: [
    CommonSvgIconsComponent,
    NgbInputDatepicker,
    NgClass,
    NgIf,
    FormsModule,
    NgForOf,
    CurrencyPipe,
    FeatherIconsComponent,
    NgSwitchCase,
    ReactiveFormsModule,
    LocationPickerComponent,
    ServiceSummaryComponent
  ],
  templateUrl: './new.component.html',
  styleUrl: './new.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class NewComponent implements OnInit {
  public tab: string = 'services-tab-1';
  /** Fecha de hoy en formato YYYY-MM-DD para min de inputs de fecha */
  public today: string = new Date().toISOString().split('T')[0];
  /** users.id del cliente activo (null si es admin) */
  public get clientId(): number | null { return this.auth.getUser()?.id ?? null; }
  /** Acceso rápido al subgrupo 'origin' para pasarlo al picker */
  public get originGroup() { return this.serviceForm.get('origin') as any; }
  /** Acceso rápido al subgrupo 'destination' para pasarlo al picker */
  public get destinationGroup() { return this.serviceForm.get('destination') as any; }
  service: any = {
    typeService: 0 //Selección de tipo de serivcio 1: A disposición 2: Traslado
  };
  listLocation: any[] = [];
  listCityOrigin: any[] = [];
  listCityDestination: any[] = [];

  capacityPassenger = 0;

  changeTab(value: string) {
    this.tab = value;
  }

  tradCards: any[] = [
    {
      bgColor: 'primary',
      icon: 'crown',
      title: 'A disposición',
      subTitle: 'Nuestra unidad y conductor se encuentran a su servicio por 10 horas o más considerando un cargo por hora extra después de las 10 horas de servicio.',
      value: 1
    },
    {
      bgColor: 'success',
      icon: 'flash',
      title: 'Servicio de Traslado',
      subTitle: 'Servicio de traslado de un punto a otro.',
      value: 2
    },
  ];
  borderClasses = ['border-success', 'border-secondary', 'border-info', 'border-primary'];
  iconCheckBox = [
    /*{
      icon: 'car', // Relacionado con transporte
      id: '1',
      title: 'Viáticos mismo día',
      checked: false,
      visible: false
    },
    {
      icon: 'hotel', // Representa hospedaje
      id: '2',
      title: 'Viáticos con hospedaje',
      checked: false,
      visible: false
    },
    {
      icon: 'moon-o', // Representa un evento nocturno
      id: '3',
      title: 'Evento nocturno',
      checked: false,
      visible: false
    },*/
    {
      icon: 'language', // Representa idiomas
      id: '4',
      title: 'Operador bilingüe',
      checked: false,
    },
    {
      icon: 'puzzle-piece', // Representa un asiento para bebé
      id: '5',
      title: 'Baby seat',
      checked: false,
    },
    {
      icon: 'paw', // Relacionado con mascotas
      id: '6',
      title: 'Transportador de mascotas',
      checked: false,
    },
    {
      icon: 'paw', // Relacionado con mascotas
      id: '8',
      title: 'Escolta',
      checked: false,
    },
    /*{
      icon: 'child', // Para una opción miscelánea
      id: '7',
      title: 'Misceláneo',
      checked: false,
      visible: false
    },*/
  ];

  //Servicio
  listService: any[] = [];
  serviceForm: FormGroup;
  listState: any[] = [];
  listCity: any[] = [];
  listMethodPay: any[] = [];


  constructor(private generalService: GeneralService, private tableService: TableService, private servicesService: ServicesService, public modalService: NgbModal, private fb: FormBuilder, private auth: AuthService) {
    this.serviceForm = this.fb.group({
      dateInit: ['', Validators.required],
      dateEnd: ['', Validators.required],
      name: ['', Validators.required],
      mail: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      origin: this.fb.group({
        cp: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
        city: ['', Validators.required],
        locality: ['', Validators.required],
        street: ['', Validators.required],
        numberExt: ['', Validators.required],
        numberInt: ['']
      }),
      destination: this.fb.group({
        cp: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
        city: ['', Validators.required],
        locality: ['', Validators.required],
        street: ['', Validators.required],
        numberExt: ['', Validators.required],
        numberInt: ['']
      }),
      passengers: ['', [Validators.required]],
      pickUp: ['', Validators.required],
      returnTime: ['', Validators.required],
      airline: [''],
      flight: [''],
      methodPay: ['', Validators.required],
      invoice: [false],
      itinerary: [''],
      recommendation: [''],
    });
  }

  ngOnInit(): void {
    //Uso comun
    this.loadList({
      "conditionColumn": "configurableListsField",
      "conditionValue": "Ubicación (servicio)",
      "idColumn": "idconfigurableLists",
      "table": "clasificacion",
      "valueColumn": "configurableListsCode"
    }, (value) => { this.listLocation = value; });

    // this.loadList({"conditionColumn":"configurableListsField",
    //   "conditionValue":"Estado",
    //   "idColumn":"idconfigurableLists",
    //   "table":"confList",
    //   "valueColumn":"configurableListsCode"}, (value) => {this.listState = value;});
    this.loadList({
      "conditionColumn": "configurableListsField",
      "conditionValue": "Ciudad",
      "idColumn": "idconfigurableLists",
      "table": "confList",
      "valueColumn": "configurableListsCode"
    }, (value) => { this.listCity = value; });
    this.loadList({
      "conditionColumn": "configurableListsField",
      "conditionValue": "Métodos de pago",
      "idColumn": "idconfigurableLists",
      "table": "confList",
      "valueColumn": "configurableListsCode"
    }, (value) => { this.listMethodPay = value; });
  }

  loadList(config: any, setVariable: (value: any) => void): void {
    this.tableService.loadSelectOptions(config).subscribe(
      (res: any) => {
        if (res.error) {
          this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
          setVariable([]);
        } else {
          setVariable(res['message']);
        }
      },
      (err) => {
        this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
        setVariable([]);
      }
    );
  }

  /*
  * Función para cambio de tipo de servicio
   */
  changeTypeService(item: any): void {
    this.listCityDestination = [];
    this.service = {};
    this.service.typeService = item.value;
    if (this.service.typeService == 2) {
      //Servicio de traslado
      this.loadCity(this.service.typeService, (value) => { this.listCityOrigin = value; });
    }
  }

  /**
   * función para obtener ciudad disponible
   * Type: tipo de servicio A disposición o Traslado
   * valueOrigin: Si viene este valor es por que se solicitan Destinos dependientes de valueOrigin, si no se solicitan los origenes
   * Si se manda -1, tomará por default Mexico
   */
  loadCity(type: number, setVariable: (value: any) => void, valueOrigin: any = null) {
    this.servicesService.getCity({ type, valueOrigin }).subscribe(
      (res: any) => {
        if (res.error) {
          this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
        } else {
          setVariable(res.message);
        }
      },
      (err) => {
        this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
      }
    );
  }

  //Función para cargar destino dependiendo el origen
  loadDestination(origin: any): void {
    //Servicio de traslado
    this.listCityDestination = [];
    this.loadCity(this.service.typeService, (value) => { this.listCityDestination = value; }, origin);
  }

  //Función para validar panel 1
  validateStep1() {
    if (this.service.typeService == 1) {
      if (!this.service.location) {
        this.generalService.showMessage('warn', 'Selecciona una ubicación.');
        return;
      }
      if (this.service.location == 'Carretera' && !this.service.destination) {
        this.generalService.showMessage('warn', 'Selecciona un destino.');
        return;
      }
    }
    if (this.service.typeService == 2) {
      if (!this.service.origin) {
        this.generalService.showMessage('warn', 'Selecciona un origen.');
        return;
      }
      if (!this.service.destination) {
        this.generalService.showMessage('warn', 'Selecciona un destino.');
        return;
      }
    }
    this.loadServices();
  }

  /*
  * Función para cargar los servicios seleccionados
   */
  loadServices(): void {
    this.listService = [];
    const user = this.auth.getUser();
    this.servicesService.getService({ data: this.service, complements: this.iconCheckBox, client_id: user?.id ?? null }).subscribe(
      (res: any) => {
        if (res.error) {
          this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
        } else {
          this.listService = res.message;
          this.changeTab('services-tab-2');
        }
      },
      (err) => {
        this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
      }
    );
  }

  /**
   * función para aceptar servicio
   */
  aceptService(item: any) {
    //Cargar datos del formulario:
    this.auth.getDataUser().subscribe(
      (res: any) => {
        if (res.error) {
          this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
        } else {
          this.changeTab('services-tab-3');

          let objMexico = this.listCity.find(item => item.value === 'México');
          let capacityItem = item.capacities.find((c: any) => c.type_id == 89);
          this.capacityPassenger = capacityItem ? capacityItem.quantity : 1;
          this.serviceForm.patchValue({
            name: res.message.name,
            mail: res.message.email,
            phone: res.message.movil,
            passengers: this.capacityPassenger
          });

          this.serviceForm.get('origin.city')?.setValue(this.service.origin ?? objMexico.id);
          this.serviceForm.get('destination.city')?.setValue(this.service.destination ?? objMexico.id);
          this.service.fee = item;
        }
      },
      (err: any) => {
        this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
      }
    );
  }

  /**
   * Formulario de un servicio
   */
  cancelFormService() {
    this.changeTab('services-tab-2');
  }

  cleanForm() {
    this.changeTab('services-tab-1');
    this.service = {
      typeService: 0
    };
    this.serviceForm.reset();
    this.iconCheckBox.forEach(item => item.checked = false);
  }

  aceptFormService() {
    if (this.serviceForm.invalid) {
      this.serviceForm.markAllAsTouched();
      return;
    }

    // Abrir primero el resumen de confirmación con desglose de IVA
    const summaryModal = this.modalService.open(ServiceSummaryComponent, { centered: true, size: 'lg' });
    const typeNames: Record<number, string> = { 1: 'A disposición', 2: 'Servicio de Traslado' };
    summaryModal.componentInstance.fee = this.service.fee;
    summaryModal.componentInstance.form = this.serviceForm.value;
    summaryModal.componentInstance.serviceTypeName = typeNames[this.service.typeService] ?? '';
    summaryModal.componentInstance.refModal = summaryModal;
    summaryModal.componentInstance.onConfirm = () => {
      //this._doSaveService();
      this.servicesService.saveService({ form: this.serviceForm.value, user: this.auth.getUser(), service: this.service }).subscribe(
          (res: any) => {
            if (res.error) {
              this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            } else {
              this.generalService.showMessage('success', res.message);
              this.cleanForm();
            }
            summaryModal.close();
          },
          (err: any) => {
            this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          }
      );
    };
  }

  /** Ejecuta el guardado real del servicio (llamado desde el summary) */
  private _doSaveService(): void {
    let modal = this.modalService.open(ConfirmComponent, { centered: true });
    modal.componentInstance.image = "assets/images/gif/successful.gif";
    modal.componentInstance.title = "¿Deseas continuar con la generación del servicio?";
    modal.componentInstance.description = "Una vez generado, el servicio será procesado. ¿Estás seguro de que deseas continuar?";
    modal.componentInstance.refModel = modal;
    modal.componentInstance.confirmAction = () => {
      this.servicesService.saveService({ form: this.serviceForm.value, user: this.auth.getUser(), service: this.service }).subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
          } else {
            this.generalService.showMessage('success', res.message);
            this.cleanForm();
          }
          modal.close();
        },
        (err: any) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
        }
      );
    };
  }

  changeCapacityPassenger(operator: any) {
    let quantityPassengerCurrently = this.serviceForm.get('passengers')?.value;
    if (operator == 1) {

      if (quantityPassengerCurrently < this.capacityPassenger) quantityPassengerCurrently++;
      else {

      }
    }
    if (operator == 2) {
      if (quantityPassengerCurrently > 1) quantityPassengerCurrently--;
      else {

      }
    }
    this.serviceForm.patchValue({
      passengers: quantityPassengerCurrently
    });

  }

  /*
  * Formulario final
  */

  //función para controlar booleano 0 o 1
  onBooleanChange(event: any): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.serviceForm.get('invoice')?.setValue(isChecked);
  }

}
